import React, { useState, useEffect } from "react";
import { FiSettings, FiTrash2, FiX } from "react-icons/fi";
import { FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom'; // Импортируем Link
import Header from '../components/Admin/Header'; // Импортируем Header
import Sidebar from '../components/Admin/Sidebar'; // Импортируем Sidebar
import { $host } from "../http";

const PromoCodePage = () => {
  // Состояния модальных окон и данных
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [promoCodes, setPromoCodes] = useState([]);
  const [newPromoCode, setNewPromoCode] = useState({});
  const [courses, setCourses] = useState([]); // Состояние для хранения курсов
  const [editingPromoCode, setEditingPromoCode] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  // Функция получения курсов
  const fetchCourses = async () => {
    try {
      const {data} = await $host.get("/api/public/courses");
      setCourses(data); // Сохраняем курсы в состояние
    } catch (error) {
      console.log("Ошибка:", error);
    }
  };

  // Функция создания промокода
  const handleCreatePromoCode = async () => {
    const payload = {
      ...newPromoCode,
      ...(newPromoCode.code && { code: newPromoCode.code }),
      ...(newPromoCode.course_id && { course_id: newPromoCode.course_id }),
      ...(newPromoCode.discount && { discount: newPromoCode.discount }),
      ...(newPromoCode.max_usages && { max_usages: newPromoCode.max_usages }),
      ...(newPromoCode.is_active !== undefined && { is_active: newPromoCode.is_active }),
    };

    if (!payload.code || !payload.discount) {
      setErrorMessage("Пожалуйста, заполните поля c названием и скидкой.");
      return;
    }

    try {
      const {data} = await $host.request("/api/admin/promocode/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
      });

      setPromoCodes([...promoCodes, data]);
      setNewPromoCode({});
      setIsCreateModalOpen(false);
      setErrorMessage("");
      fetchPromoCodes();
    } catch (error) {
      setErrorMessage(error.message || "Произошла ошибка, попробуйте еще раз.");
    }
  };

  // Функция редактирования промокода
  const handleEditPromoCode = async () => {
    const payload = {
      ...editingPromoCode,
      ...(editingPromoCode.code && { code: editingPromoCode.code }),
      ...(editingPromoCode.discount && { discount: editingPromoCode.discount }),
      ...(editingPromoCode.max_usages && { max_usages: editingPromoCode.max_usages }),
      ...(editingPromoCode.course_id && { course_id: editingPromoCode.course_id }),
    };

    if (!payload.code || !payload.discount) {
      setErrorMessage("Пожалуйста, заполните поля c названием и скидкой.");
      return;
    }

    try {
      const response = await $host.request(`/api/admin/promocode/update/${editingPromoCode.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
      });

      const updatedPromoCode = response.data
      setPromoCodes(promoCodes.map(code => (code.id === updatedPromoCode.id ? updatedPromoCode : code)));
      setIsEditModalOpen(false);
      setEditingPromoCode(null);
      fetchPromoCodes();
    } catch (error) {
      setErrorMessage(error.message || "Произошла ошибка, попробуйте еще раз.");
    }
  };

  // Функция получения всех промокодов
  const fetchPromoCodes = async () => {
    try {
      const response = await $host.get("/api/admin/promocode/list",);

      setPromoCodes(response.data);
    } catch (error) {
      console.log("Ошибка:", error);
    }
  };

  useEffect(() => {
    fetchPromoCodes(); // Получаем промокоды при монтировании компонента
    fetchCourses(); // Получаем курсы при монтировании компонента
  }, []);

// Функция удаления промокода
const handleDeletePromoCode = async (id) => {
  try {
    await $host.request(`/api/admin/promocode/${id}`, {
      method: "DELETE",
    });
    await fetchPromoCodes();

  } catch (error) {
    console.error('Ошибка:', error);
  }
};

  return (
    <div>
      <Header />

      <div className="flex min-h-screen bg-gray-100">
        <Sidebar /> {/* Используем компонент Sidebar */}

        {/* Main Content */}
        <main className="flex-1 p-8 bg-[#F3F1FB4D]">
          {/* Breadcrumbs */}
          <nav className="w-full rounded-md mb-8">
            <ol className="list-reset flex">
              <li>
                <Link
                  to="/promocode" 
                  className="text-[black] text-primary transition duration-150 ease-in-out hover:text-primary-accent-300 focus:text-primary-accent-300 active:text-primary-accent-300 motion-reduce:transition-none dark:text-primary-400"
                >
                  Промокоды
                </Link>
              </li>
              <li>
                <span className="mx-2 text-neutral-400">/</span>
              </li>
              <li className="text-neutral-400">Всего {promoCodes.length} промокодов</li>
            </ol>
          </nav>

          <button
            onClick={() => setIsCreateModalOpen(true)}
            className="w-full bg-[#6446C314] hover:bg-[#6446C31F] text-[#6446C3] font-semibold py-4 px-6 rounded-lg transition-colors focus:outline-none mb-4 flex items-center justify-center"
            aria-label="Add Promo Code"
          >
            <FaPlus className="text-1xl" />
          </button>

          {/* Promo Code Section */}
          <div className="bg-white rounded-lg shadow-lg p-6" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            <h1 className="text-2xl font-bold text-gray-800 mb-4">Промокоды</h1>
            <div className="space-y-4">
              {promoCodes.map((code) => (
                <div key={code.id} className="flex items-center justify-between p-4 bg-[#6446C314] rounded-lg">
                  <span className="font-bold text-[#6446C3]">{code.code}</span>
                  <div className="flex space-x-2 items-center">
                    <span className="mr-10 text-gray-600">
                      {code.max_usages === 0 ? (
                        <span className="font-medium text-[#6446C3]">Безлимитный</span>
                      ) : (
                        <>
                          Осталось <span className="font-medium text-[#6446C3]">{code.max_usages - code.usages}</span> использований
                        </>
                      )}
                    </span>
                    <button
                      onClick={() => {
                        setEditingPromoCode(code);
                        setIsEditModalOpen(true);
                      }}
                      className="p-2 text-gray-600 hover:text-blue-600 transition-colors"
                      aria-label="Edit promo code"
                    >
                      <FiSettings />
                    </button>
                    <button
                      onClick={() => handleDeletePromoCode(code.id)}
                      className="p-2 text-gray-600 hover:text-red-600 transition-colors"
                      aria-label="Delete promo code"
                    >
                      <FiTrash2 />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </main>

        {/* Модальное окно создания промокода */}
        {isCreateModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 w-[60%]">
              <div className="flex justify-between items-center mb-4">
                <h1 className="text-xl font-medium">Создать промокод</h1>
                <button 
                  onClick={() => {
                    setIsCreateModalOpen(false);
                    setNewPromoCode({});
                    setErrorMessage(""); 
                  }}
                  className="text-gray-500 hover:text-gray-700 text-2xl"
                >
                  <FiX />
                </button>
              </div>
              <div className="space-y-4">
                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                
                {/* Поле для названия промокода */}
                <div className="flex items-center mb-2">
                  <label className="w-1/3 font-medium text-[#363645]">Название:
                    <span className="text-red-500 ml-1">*</span> {/* Красная звездочка */}
                  </label>
                  <input 
                    type="text" 
                    value={newPromoCode.code} 
                    onChange={(e) => setNewPromoCode({ ...newPromoCode, code: e.target.value })} 
                    placeholder="Введите название" 
                    className="w-2/3 h-[50px] border-b border-[#6446C3] outline-none placeholder-[#3636454D] font-medium text-[#6446C3]" 
                    style={{ borderBottom: '2px solid #6446C3' }}
                  />
                </div>

                {/* Поле для выбора курса */}
                <div className="flex items-center mb-2">
                  <label className="w-1/3 font-medium text-[#363645]">Курс:</label>
                  <select
                    value={newPromoCode.course_id}
                    onChange={(e) => setNewPromoCode({ ...newPromoCode, course_id: e.target.value })}
                    className="w-2/3 h-[50px] border-b border-[#6446C3] outline-none placeholder-[#3636454D] font-medium text-[#6446C3]"
                    style={{ borderBottom: '2px solid #6446C3' }}
                  >
                    <option value="">Выберите курс</option>
                    {courses.map((course) => (
                      <option key={course.id} value={course.id}>
                        {course.title} {/* Отображаемое название курса */}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Поле для скидки */}
                <div className="flex items-center mb-2">
                  <label className="w-1/3 font-medium text-[#363645]">Скидка:
                    <span className="text-red-500 ml-1">*</span> {/* Красная звездочка */}
                  </label>
                  <input 
                    type="number" 
                    value={newPromoCode.discount} 
                    onChange={(e) => setNewPromoCode({ ...newPromoCode, discount: Number(e.target.value) })} 
                    placeholder="Введите скидку" 
                    className="w-2/3 h-[50px] border-b border-[#6446C3] outline-none placeholder-[#3636454D] font-medium text-[#6446C3]" 
                    style={{ borderBottom: '2px solid #6446C3' }}
                  />
                </div>

                {/* Поле для максимального использования */}
                <div className="flex items-center mb-4">
                  <label className="w-1/3 font-medium text-[#363645]">Макс. использования:</label>
                  <input 
                    type="number" 
                    value={newPromoCode.max_usages} 
                    onChange={(e) => setNewPromoCode({ ...newPromoCode, max_usages: Number(e.target.value) })} 
                    placeholder="Макс. использования" 
                    className="w-2/3 h-[50px] border-b border-[#6446C3] outline-none placeholder-[#3636454D] font-medium text-[#6446C3]" 
                    style={{ borderBottom: '2px solid #6446C3' }}
                  />
                </div>

                <button onClick={handleCreatePromoCode} className="bg-[#6446C3] w-full h-[42px] text-white rounded-[16px]">Создать промокод</button>
              </div>
            </div>
          </div>
        )}

        {/* Модальное окно редактирования промокода */}
        {isEditModalOpen && editingPromoCode && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 w-[60%]">
              <div className="flex justify-between items-center mb-4">
                <h1 className="text-xl font-medium">Изменить промокод</h1>
                <button 
                  onClick={() => {
                    setIsEditModalOpen(false);
                    setNewPromoCode({});
                    setErrorMessage(""); 
                  }}
                  className="text-gray-500 hover:text-gray-700 text-2xl"
                >
                  <FiX />
                </button>
              </div>
              <div className="space-y-4">
                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                
                {/* Поле для названия промокода */}
                <div className="flex items-center mb-2">
                  <label className="w-1/3 font-medium text-[#363645]">Название:
                    <span className="text-red-500 ml-1">*</span> {/* Красная звездочка */}
                  </label>
                  <input 
                    type="text" 
                    value={editingPromoCode.code} 
                    onChange={(e) => setEditingPromoCode({ ...editingPromoCode, code: e.target.value })} 
                    placeholder="Введите название" 
                    className="w-2/3 h-[50px] border-b border-[#6446C3] outline-none placeholder-[#3636454D] font-medium text-[#6446C3]" 
                    style={{ borderBottom: '2px solid #6446C3' }}
                  />
                </div>

                {/* Поле для скидки */}
                <div className="flex items-center mb-2">
                  <label className="w-1/3 font-medium text-[#363645]">Скидка:
                    <span className="text-red-500 ml-1">*</span> {/* Красная звездочка */}
                  </label>
                  <input 
                    type="number" 
                    value={editingPromoCode.discount} 
                    onChange={(e) => setEditingPromoCode({ ...editingPromoCode, discount: Number(e.target.value) })} 
                    placeholder="Введите скидку" 
                    className="w-2/3 h-[50px] border-b border-[#6446C3] outline-none placeholder-[#3636454D] font-medium text-[#6446C3]" 
                    style={{ borderBottom: '2px solid #6446C3' }}
                  />
                </div>

                {/* Поле для выбора курса */}
                <div className="flex items-center mb-2">
                  <label className="w-1/3 font-medium text-[#363645]">Курс:</label>
                  <select
                    value={editingPromoCode.course_id} // Используем course_id из редактируемого промокода
                    onChange={(e) => setEditingPromoCode({ ...editingPromoCode, course_id: e.target.value })}
                    className="w-2/3 h-[50px] border-b border-[#6446C3] outline-none placeholder-[#3636454D] font-medium text-[#6446C3]"
                    style={{ borderBottom: '2px solid #6446C3' }}
                  >
                    <option value="">Выберите курс</option>
                    {courses.map((course) => (
                      <option key={course.id} value={course.id}>
                        {course.title} {/* Отображаемое название курса */}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Поле для максимального использования */}
                <div className="flex items-center mb-4">
                  <label className="w-1/3 font-medium text-[#363645]">Макс. использования:</label>
                  <input 
                    type="number" 
                    value={editingPromoCode.max_usages} 
                    onChange={(e) => setEditingPromoCode({ ...editingPromoCode, max_usages: Number(e.target.value) })} 
                    placeholder="Макс. использования" 
                    className="w-2/3 h-[50px] border-b border-[#6446C3] outline-none placeholder-[#3636454D] font-medium text-[#6446C3]" 
                    style={{ borderBottom: '2px solid #6446C3' }}
                  />
                </div>

                <button onClick={handleEditPromoCode} className="bg-[#6446C3] w-full h-[42px] text-white rounded-[16px]">Обновить промокод</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PromoCodePage;
